export const SOCIAL_LINKS = {
  Facebook: "https://www.facebook.com/FoothillTechnologySolutions",
  LinkedIn:
    "https://www.linkedin.com/company/foothill-technology-solutions-llc./",
  Youtube: "https://www.youtube.com/channel/UCzPMvg55AtrugaIamuTslUA",
}
